<template>
  <div style="margin-top: 113px">
    <v-container>
      <v-card>
        <v-card-title>Bilan campaigns</v-card-title>
        <v-snackbar v-model="isMsg" :color="getColor()">
          <b>{{ message }}</b>
        </v-snackbar>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr class="general-background">
                  <th class="text-left col-elem border-elem">
                    <b>Année</b>
                  </th>
                  <th class="text-left col-elem border-elem">
                    <b>Statut</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:12%">
                    <b>Date de création</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:15%">
                    <b>période</b>
                  </th>
                  <th class="text-left col-elem border-elem">
                    <b>Nombre de bilans total </b>
                  </th>

                  <th class="text-left col-elem border-elem">
                    <b>Nombre de bilans en proposition manager</b>
                  </th>
                  <th class="text-left col-elem border-elem">
                    <b>Nombre de bilans en employée notification </b>
                  </th>
                  <th class="text-left col-elem border-elem">
                    <b>Nombre de bilans fermés</b>
                  </th>
                  <th class="text-left col-elem border-elem" style="width:25%">
                    <b>Action</b>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="campaign in campaigns" v-bind:key="campaign.id">
                  <th class="text-left border-elem">{{ campaign.year }}</th>
                  <th class="text-left border-elem">{{ campaign.status }}</th>
                  <th class="text-left border-elem">
                    {{ campaign.startingDate }}
                  </th>
                  <th class="text-left border-elem">
                    De: {{ campaign.startPeriod }} &nbsp; &nbsp; &nbsp; &nbsp;
                    &nbsp; A: {{ campaign.endPeriod }}
                  </th>
                  <th class="text-left border-elem">{{ campaign.nbBilans }}</th>
                  <th class="text-left border-elem">
                    {{ campaign.nbBilansManProp }}
                  </th>
                  <th class="text-left border-elem">
                    {{ campaign.nbBilansEmpNotif }}
                  </th>
                  <th class="text-left border-elem">
                    {{ campaign.nbBilansClosed }}
                  </th>
                  <th class="text-left border-elem">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          @click="closeCampaign(campaign.year)"
                          v-if="campaign.status != 'CLOSED'"
                        >
                          <v-icon color="red">mdi-stop-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Attention ! Fermeture de la campagne</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          v-on="on"
                          text
                          @click="csv(campaign.year, false)"
                        >
                          <v-icon>mdi-file-delimited-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Exporter en CSV</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text @click="csv(campaign.year, true)">
                          <v-icon>mdi-database-export</v-icon>
                        </v-btn>
                      </template>
                      <span>Exporter toute les données en CSV</span>
                    </v-tooltip>
                  </th>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-form ref="formNotification" v-model="valider">
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="3">
                  <h6>Prochaine Campagne</h6>
                </v-col>
                <v-col cols="2">
                  <h6>Période</h6>
                  <v-menu :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        required
                        :rules="notificationAchievementRules"
                        v-model="startPeriod"
                        label="Période de Début"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startPeriod"
                      color="#00635b"
                    ></v-date-picker>
                  </v-menu>
                  <v-menu :close-on-content-click="false">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        required
                        :rules="notificationAchievementRules"
                        v-model="endPeriod"
                        label="Période de Fin"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endPeriod"
                      color="#00635b"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="1"> </v-col>
                <v-col cols="2">
                  <h6>Année</h6>
                  <v-radio-group v-model="nextCampaignYear">
                    <v-radio
                      :label="'' + currentYear"
                      :value="currentYear"
                    ></v-radio>
                    <v-radio :label="'' + nextYear" :value="nextYear"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    @click="startCampaign"
                    class=" ml-2 mb-3"
                    color="success"
                  >
                    Demarer La Campagne {{ nextCampaignYear }}</v-btn
                  >
                  <v-progress-circular
                    v-if="wait"
                    indeterminate
                    color="green"
                  ></v-progress-circular>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-form>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="400">
        <v-card>
          <v-card-title class="headline"
            ><span
              >Fermeture de la campagne {{ campaignToClose }}
            </span></v-card-title
          >
          <v-card-text>
            <v-container>
              <span>
                Etes vous sur de vouloir fermer la campagne
                {{ campaignToClose }} ?</span
              >
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    type="password"
                    label="Mot de passe"
                    required
                    v-model="confirmPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog = false"
              >Non</v-btn
            >
            <v-btn color="red darken-1" text @click="close(false)">Oui</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
    <v-snackbar
      v-model="snackbar"
      :color="snackBarColor"
      :timeout="snackBarTimeout"
    >
      <b>{{ snackBarText }} </b>
    </v-snackbar>
  </div>
</template>

<style>
h6 {
  color: gray;
}
</style>
<script>
export default {
  name: "campaigneBilan",

  data() {
    return {
      startPeriod: null,
      endPeriod: null,
      campaigns: [],
      wait: false,
      message: "",
      error: false,
      isMsg: false,
      nextCampaignYear: new Date().getFullYear() + 1,
      currentYear: new Date().getFullYear(),
      nextYear: new Date().getFullYear() + 1,
      dialog: false,
      campaignToClose: null,
      confirmPassword: null,
      valider: true,
      notificationAchievementRules: [
        (v) => v != null || "This field is required",
        (v) => v !== "" || "This field is required",
      ],
      snackbar: false,
      snackBarText: "",
      snackBarColor: "",
      snackBarTimeout: 2000,
    };
  },
  computed: {},
  mounted: function() {
    this.loadCampaigns();
  },
  methods: {
    csv(year, all) {
      var apiPath = "api/bilans/export/";
      if (all) {
        apiPath = "api/bilans/exportAll/";
      }
      fetch(process.env.VUE_APP_ROOT_API_PATH + apiPath + year, {
        method: "GET",
        credentials: "include",
        responseType: "blob",
      })
        .then((response) => {
          return response.blob();
        })
        .then((blob) => {
          var url = window.URL.createObjectURL(blob);
          var a = document.createElement("a");
          a.href = url;
          if (all) {
            a.download = "Export-bilans-full.csv";
          } else {
            a.download = "Export-bilans.csv";
          }
          document.body.appendChild(a);
          a.click();
          a.remove();
        });
    },
    loadCampaigns() {
      fetch(process.env.VUE_APP_ROOT_API_PATH + "api/campaingsBilan", {
        method: "get",
        credentials: "include",
      })
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          this.campaigns = response.data;
          this.wait = false;
        });
    },
    startCampaign: function() {
      if (this.$refs.formNotification.validate()) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        this.wait = true;
        fetch(
          process.env.VUE_APP_ROOT_API_PATH +
            "api/campaingsBilan?year=" +
            this.nextCampaignYear +
            "&startPeriod=" +
            this.startPeriod +
            "&endPeriod=" +
            this.endPeriod,
          {
            method: "POST",
            credentials: "include",
            headers: myHeaders,
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            if (json.status == "200") {
              this.error = false;
              this.isMsg = true;
              this.wait = false;
              this.message = json.data;
              this.loadCampaigns();
            } else {
              this.error = true;
              this.isMsg = true;
              this.message = json.message;
            }
          })
          .catch((err) => {
            this.error = true;
            this.isMsg = true;
            this.message = err;
            this.wait = false;
          });
      } else {
        this.snackbar = true;
        this.snackBarText = "Check all fields in red";
        this.snackBarColor = "error";
      }
    },
    getColor: function() {
      if (this.error) {
        return "red darken-2";
      } else {
        return "green darken-2";
      }
    },
    closeCampaign: function(yearToClose) {
      this.campaignToClose = yearToClose;
      this.dialog = true;
    },
    close: function() {
      this.dialog = false;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      this.wait = true;
      fetch(
        process.env.VUE_APP_ROOT_API_PATH +
          "api/campaingsBilan?year=" +
          this.campaignToClose +
          "&password=" +
          this.confirmPassword,
        {
          method: "PUT",
          credentials: "include",
          headers: myHeaders,
        }
      )
        .then((response) => {
          this.confirmPassword = "";
          return response.json();
        })
        .then((json) => {
          if (json.status == "200") {
            this.loadCampaigns();
          } else {
            this.wait = false;
            this.error = true;
            this.isMsg = true;
            this.message = json.message;
          }
        })
        .catch((err) => {
          this.error = true;
          this.isMsg = true;
          this.message = err;
        });
    },
  },
};
</script>
